import {CLEAR_PERSONAL_REPORT, FETCH_PERSONAL_REPORT, LIST_PERSONAL_REPORT, LOADING_PERSONAL_REPORT} from "./types";

const init = {
    isLoading: false,
    data: {},
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PERSONAL_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PERSONAL_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_PERSONAL_REPORT:
            return {
                isLoading: false,
                data: []
            };
        case LOADING_PERSONAL_REPORT:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state

    }
}
